<template>
  <div>
    <a-drawer
      class="role__edit"
      :visible="visible"
      :width="650"
      :title="`${role ? '编辑': '新建'}角色`"
      @ok="handleOk"
      @cancel="handleCancel"
      @close="handleCancel"
      :mask-closable="false"
      destroy-on-close
    >
      <a-form
        class="role__edit__form"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
        :form="form"
      >
        <template v-if="!role || (role && roleDetail)">
          <a-form-item label="角色名称">
            <a-input
              v-decorator="['roleName', {
                initialValue: role ? role.roleName : undefined,
                rules: [
                  {
                    required: true,
                    message: '请输入角色名称',
                  },
                ]
              }]"
              placeholder="角色名称"
              autocomplete="off"
            />
          </a-form-item>
          <div>
            <div class="mvp-title-wrapper">
              <h3 class="mvp-title">角色权限</h3>
            </div>
          </div>
          <a-form-item
            v-for="item in formatTree"
            :label="item.functionName"
            :key="item.id"
          >
            <a-switch
              @change="handleSwitch(item.id)"
              v-model="auth[item.id]"
            />
            <span
              v-if="auth[item.id]"
              @click="handleExpendChange(item.id)"
              class="expand"
            >
              <span v-if="!showMaps[item.id]">
                展开权限 <a-icon type="down" />
              </span>
              <span v-else>
                收起权限 <a-icon type="up" />
              </span>
            </span>
            <a-tree
              v-model="authIdMaps[item.id]"
              v-if="auth[item.id] && showMaps[item.id]"
              checkable
              :tree-data="(formatTree.find(i => i.id === item.id) || {}).children || []"
            >
              <span
                v-if="slotsIds.includes(id)"
                slot="label"
                slot-scope="{ id, functionName }"
              >
                {{ functionName }}
                <span
                  style="color: #44C7D8; font-size: 12px"
                  @click="handleConfig($event, id)"
                >
                  配置功能权限
                </span>
              </span>
            </a-tree>
          </a-form-item>
        </template>
      </a-form>
      <div class="role__edit__action-list">
        <a-button
          @click="handleCancel"
          class="role__edit__action"
        >取消</a-button>
        <a-button
          type="primary"
          @click="handleOk"
          class="role__edit__action"
        >提交</a-button>
      </div>
    </a-drawer>
    <aside>
      <a-modal
        title="配置功能权限"
        :visible="modalVisible"
        @ok="handleSubmitModal"
        @cancel="handleCancelModal"
      >
        <a-row>
          <a-col
            :span="8"
            v-for="{id, functionName} in childrenList"
            :key="id"
          >
            <a-checkbox
              :value="id"
              @change="handleChecked($event, id)"
              :checked="btnIdsList.includes(id)"
            >
              {{ functionName }}
            </a-checkbox>
          </a-col>
        </a-row>
      </a-modal>
    </aside>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { convertListToTree } from '@/utils/helpers';
import {
  Product,
  ProductText,
} from '@/consts/product';
import { message } from 'ant-design-vue';

const deepCheckIds = (arr = [], ids = [], result = []) => {
  arr.forEach((i) => {
    if (i.children) {
      deepCheckIds(i.children, ids, result);
    } else if (!i.children && ids.includes(i.id)) {
      result.push(i.id);
    }
  });
};

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    role: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      modalVisible: false,
      btnIdsList: [],
      childrenList: [],
      Product,
      ProductText,
      showMaps: {}, // 控制展开收缩
      authIdMaps: {}, // 具体菜单内部权限的集合
      auth: {}, // 最外面层级菜单的权限集合
      form: this.$form.createForm(this, { name: 'role_edit' }),
    };
  },
  computed: {
    ...mapState('role', [
      'roleDetail',
      'funcList',
      'slotsIds',
    ]),
    ...mapState('user', ['userInfo']),
    formatTree() {
      const btnList = this.funcList.filter(i => i.functionType === 'BUTTON');
      const slotsIds = this.funcList.filter(i => btnList.find(subItem => subItem.parentId === i.id)).map(i => i.id);
      const dataList = this.funcList.filter(i => i.functionType === 'MENU' || !i.functionType).map(i => ({
        ...i,
        key: i.id,
        label: slotsIds.includes(i.id) ? undefined : i.functionName,
        title: slotsIds.includes(i.id) ? undefined : i.functionName,
        scopedSlots: slotsIds.includes(i.id) ? { title: 'label' } : undefined,
      }));
      const result = convertListToTree(dataList, 'parentId', 'id', 0).children || [];
      return result;
    },
  },
  methods: {
    handleSwitch(id) {
      this.showMaps = { ...this.showMaps, [id]: true };
    },
    getAllIds(origin = [], id) {
      let target = this.funcList.find(l => l.id === id);
      if (target) {
        origin.push(target.id);
        while (target.parentId !== 0) {
          // eslint-disable-next-line no-loop-func
          target = this.funcList.find(l => l.id === target.parentId);
          if (target) {
            origin.push(target.id);
          }
        }
      }
      return origin;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let outIds = [];
          Object.keys(this.auth).forEach((i) => {
            if (this.auth[i]) {
              outIds = [...outIds, Number(i)];
            }
          });
          let inIds = [];
          Object.keys(this.authIdMaps).filter(i => outIds.includes(Number(i))).forEach((i) => {
            this.authIdMaps[i].forEach((subItem) => {
              inIds = this.getAllIds(inIds, subItem);
            });
          });
          const finalIds = [...outIds, ...Array.from(new Set(inIds))];
          if (inIds.length === 0 || inIds.length === 0) {
            message.error('请至少选择一个权限');
            return;
          }
          this.$emit('ok', {
            roleName: values.roleName,
            functionIds: Array.from(new Set([...finalIds, ...this.btnIdsList])),
          });
        }
      });
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleConfig(e, id) {
      e.stopPropagation();
      this.modalVisible = true;
      this.childrenList = this.funcList.filter(i => i.parentId === id && i.functionType === 'BUTTON');
    },
    handleSubmitModal() {
      this.modalVisible = false;
    },
    handleCancelModal() {
      this.modalVisible = false;
    },
    handleChecked(e, id) {
      const value = e.target.checked;
      if (value) {
        this.btnIdsList = [...this.btnIdsList, id];
      } else {
        this.btnIdsList = this.btnIdsList.filter(i => i !== id);
      }
    },
    handleExpendChange(key) {
      this.showMaps[key] = !this.showMaps[key];
    },
    handleTreeChange(id, keys) {
      this.authIdMaps = { ...this.authIdMaps, [id]: keys };
    },
  },
  created() {
    this.$store.dispatch('role/fetchFuncList').then(() => {
      if (this.role) {
        this.$store.dispatch('role/fetchDetail', { roleId: this.role.id })
          .then(() => {
            const {
              functionIds,
            } = this.roleDetail;
            const dataList = this.funcList.filter(i => i.functionType === 'MENU');
            const outIds = this.funcList.filter(i => i.functionType === 'MENU' && i.parentId === 0 && functionIds.includes(i.id)).map(i => i.id);
            const btnIdsInList = this.funcList.filter(i => i.functionType === 'BUTTON').map(i => i.id);
            this.btnIdsList = functionIds.filter(i => btnIdsInList.includes(i));
            const formatList = convertListToTree(dataList, 'parentId', 'id', 0).children;
            const outAuthMaps = {};
            const authIdsMaps = {};
            const showMaps = {};
            outIds.forEach((i) => {
              const currentTree = (formatList.find(item => item.id === i) || {}).children || [];
              const currentTreeFlattenIds = [];
              deepCheckIds(currentTree, functionIds, currentTreeFlattenIds);
              showMaps[i] = true;
              outAuthMaps[i] = !!i;
              authIdsMaps[i] = currentTreeFlattenIds; // 需要从树结构中获取我们要的对应的id
            });
            this.authIdMaps = authIdsMaps;
            this.showMaps = showMaps;
            this.auth = outAuthMaps;
          });
      }
    });
  },
};
</script>

<style lang="less" scoped>
.role__edit {
  &__form {
    padding-bottom: 24px;
  }
  .expand {
    float: right;
    color: var(--main-color);
    cursor: pointer;
  }
  &__action {
    &-list {
      position: absolute;
      z-index: 3;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      padding: 10px 16px;
      border-top: 1px solid var(--border-color-split);
      text-align: right;
      background-color: var(--main-bg);
    }
  }
}
</style>
